import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CSButtonComponent } from '../../cs-button/cs-button.component';
import { CSIconButtonComponent } from '../../cs-icon-button/cs-icon-button.component';

type TData = {
  data: unknown;
  type: 'success' | 'error' | 'info';
  header: string;
  title: string;
  message?: string;
  cancelText?: string;
  confirmText: string;
  customizedConfirmButton?: TemplateRef<any>;
  color: 'primary' | 'accent' | 'danger';
  textAlign?: 'left' | 'center';
  confirmCallback: (data: unknown) => void;
  cancelCallback?: (data: unknown) => void;
};

const ICON_TYPE = { success: 'fi-check-circle', error: 'fi-x-circle', info: '' };
@Component({
  selector: 'app-cs-confirm-popup',
  standalone: true,
  imports: [CSButtonComponent, CSIconButtonComponent, CommonModule],
  templateUrl: './cs-confirm-popup.component.html',
  styleUrl: './cs-confirm-popup.component.scss',
})
export class CsConfirmPopupComponent implements OnInit {
  // Input 屬性，可以從模板直接傳入
  @Input() type: 'success' | 'error' | 'info' = 'success';
  @Input() header: string = '';
  @Input() title: string = '';
  @Input() message?: string | Array<string>;
  @Input() cancelText?: string;
  @Input() confirmText: string = '';
  @Input() color: 'primary' | 'accent' | 'danger' = 'primary';
  @Input() inputData: unknown;
  @Input() textAlign: 'left' | 'center' = 'center';
  @Input() customizedConfirmButton?: TemplateRef<any>;

  // 當確認按鈕被點擊時觸發的事件
  @Output() confirm = new EventEmitter<unknown>();
  @Output() cancel = new EventEmitter<void>();

  // 用於顯示圖標
  icon: string = '';
  // 從Dialog傳入的數據
  protected dialogData: TData | null = null;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) dialogData: TData | null,
    @Optional() public dialogRef: MatDialogRef<CsConfirmPopupComponent>,
  ) {
    this.dialogData = dialogData;
    if (dialogData) {
      // 如果是通過Dialog打開，使用Dialog數據
      this.type = dialogData.type;
      this.header = dialogData.header;
      this.title = dialogData.title;
      this.message = dialogData.message;
      this.cancelText = dialogData.cancelText;
      this.confirmText = dialogData.confirmText;
      this.color = dialogData.color;
      this.inputData = dialogData.data;
      this.textAlign = dialogData.textAlign || 'center';
      this.customizedConfirmButton = dialogData.customizedConfirmButton;
    }
  }
  // 判斷message是否是array
  isArrayMessage(): boolean {
    return Array.isArray(this.message);
  }

  ngOnInit(): void {
    // 初始化圖標
    this.updateIcon();
  }

  // 當屬性改變時更新圖標
  updateIcon(): void {
    this.icon = ICON_TYPE[this.type];
  }

  // 確認按鈕點擊處理
  onConfirm(): void {
    if (this.dialogData && this.dialogData.confirmCallback) {
      // 如果是Dialog模式，調用回調函數
      this.dialogData.confirmCallback(this.inputData);
      if (this.dialogRef) {
        this.dialogRef.close(this.inputData);
      }
    } else {
      // 如果是直接使用模式，發出事件
      this.confirm.emit(this.inputData);
    }
  }

  // 取消按鈕點擊處理
  onCancel(): void {
    if (this.dialogData?.cancelCallback) {
      this.dialogData.cancelCallback(this.inputData);
    }
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.cancel.emit();
    }
  }
}
